import { useEffect, useState } from "react";
export const useScreen = (size = 1170) => {
  // Initialize screenSize with 0 or a default value that makes sense for your server-side rendering
  const [screenSize, setScreenSize] = useState(0);
  useEffect(() => {
    // Ensure window is defined (i.e., we're running in the browser)
    if (typeof window !== "undefined") {
      // Now we can safely use window
      const handleDisplayResize = () => {
        setScreenSize(window.innerWidth);
      };

      // Set initial value based on current window size
      setScreenSize(window.innerWidth);
      window.addEventListener("resize", handleDisplayResize);
      return () => {
        window.removeEventListener("resize", handleDisplayResize);
      };
    }
  }, []);
  return screenSize <= size;
};